import { SessionProvider, authConfigManager } from "@hono/auth-js/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

import LetterBackground from "./components/letter-background";
import { ThemeProvider } from "./components/theme-provider";
import "./index.css";
import Router from "./router";

authConfigManager.setConfig({
  basePath: "/api/auth", // if auth route is diff from /api/auth
});

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="dark">
        <LetterBackground>
          <SessionProvider>
            <Router />
            <Toaster />
          </SessionProvider>
        </LetterBackground>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
